// 我的投资
<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">我的投资</div>
      <choose-search @handleQuery="changeQuery" :searchInfo.sync="search"></choose-search>
      <div class="table">
        <el-table class="financial-services-table" :data="tableData" v-loading="Loading" :header-cell-style="{
            textAlign: 'center',
            background: '#FAFAFA',
            color: '#3F434B',
          }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="name" label="标的名称"></el-table-column>
          <el-table-column prop="areaConfigName" label="区域"></el-table-column>
          <el-table-column prop="businessTypeDesc" label="业务类型"></el-table-column>
          <el-table-column prop="delistingStatus" label="交易方式">
            <template slot-scope="scope">{{
              scope.row.tranferType == 1
                ? '网络竞价'
                : scope.row.tranferType == 2
                ? '协议转让'
                : scope.row.tranferType == 3
                ? '预售'
                : '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="date" label="开始时间" width="150px">
            <template slot-scope="scope">{{
              scope.row.startTime | datetimeFormat
            }}</template>
          </el-table-column>
          <el-table-column prop="date" label="结束时间" width="150px">
            <template slot-scope="scope">{{
              scope.row.endTime | datetimeFormat
            }}</template>
          </el-table-column>
          <el-table-column prop="transactionPrice" label="成交价款（元）"></el-table-column>
          <el-table-column prop="delistingStatus" label="投资状态" width="80px">
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="scope.row.delistingStatus != '0' && goInvestDetail(scope.row)">
              {{scope.row.delistingStatus == '0' ? '竞价中' : scope.row.delistingStatus == '1' ? '已成交' : '未成交' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="支付状态">
            <template slot-scope="scope">
              <span v-if="scope.row.auditStatus == 0">审核中</span>
              <span v-else-if="scope.row.payType == 3 && scope.row.payStatus == 4">交付后再付</span>
              <span v-else-if="scope.row.auditStatus == 2">未到账</span>
              <span v-else-if="scope.row.payStatus == 2 && scope.row.auditStatus == 1">部分已到账</span>
              <span v-else-if="scope.row.payStatus == 1 && scope.row.auditStatus == 1">全部已到账</span>
              <span v-else-if="scope.row.payStatus == 3 && scope.row.auditStatus == 1">未到账</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="payStatus" label="其他操作">
            <template slot-scope="scope">
             <div>
                <div v-if="scope.row.tranferType != 1&&scope.row.isPriceStatus==0" class="blueC" @click="diaPayEvtS(scope.row,'nonAuction')">重新支付</div>
                <div v-if="scope.row.tranferType == 1&&scope.row.isPriceStatus==0&&scope.row.businessType!=7" class="blueC" @click="diaPayEvtS(scope.row,'transactionPrice')">重新支付成交价</div>
                <div v-if="scope.row.tranferType == 1&&scope.row.isTransactionStatus==0&&scope.row.businessType!=7" class="blueC" @click="diaPayEvtS(scope.row,'transactionAmount')">重新支付服务费</div>
             </div>
<!--              <span v-if="scope.row.auditStatus == 2 && scope.row.delistingStatus != 3" class="blueC" @click="diaPayEvtS(scope.row)">重新支付</span>-->
              <div>
                <span v-if="scope.row.delistingStatus == 3 && scope.row.status == 3" class="blueC" @click="applyEvt(scope.row)">重新摘牌</span>
                <span v-else-if="(scope.row.auditStatus == 1 && scope.row.payStatus != 1) || (scope.row.payType == 3 && scope.row.payStatus == 0)" class="blueC" @click="diaPayEvt(scope.row)">支付余款</span>
                <span v-else-if="scope.row.tranferType == 1 && (scope.row.status == 11 || scope.row.status == 12 || scope.row.status == 13)" class="blueC" @click="goSureBook(scope.row)">查看成交确认书</span>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <Pagination :total="paginationParam.total" :page.sync="paginationParam.pageNumber" :limit.sync="paginationParam.pageSize" @pagination="getTransactionList" />
      </div>
      <!-- 中止挂牌 -->
      <Dialog :show="diaShow" @dialogClose="diaShow = false" :title="'温馨提示'" :content="'确定申请中止挂牌？'" :btn="'取消'" :btn2="'确定'" />
      <!-- 支付余款 -->
      <el-dialog title="支付余款" v-loading.fullscreen.lock="loading" :visible.sync="show" :close-on-click-modal="false" width="60%">
        <div class="transfer_wrap">
          <div style="margin: 0 50px 30px" v-if="tranferType == 1">
            <span class="mr20">是否抵扣保证金</span>
            <el-radio-group v-model="residueInfo.usePromiseAmount" disabled>
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </div>
          <div class="h_bg p50" style="margin-top: 0">
            <h3>转账信息</h3>
            <span>请根据以下银行信息进行缴费，缴费完成后，上传缴费凭证</span>
          </div>
          <div class="p50">
            <div class="mb10" v-if="tranferType == 1">
              <span class="wid">实际支付剩余余款（元）</span>
              <span class="redF" v-if="residueInfo.usePromiseAmount">{{
                residueInfo.promiseAmount
                  ? Number(residueInfo.amount - residueInfo.promiseAmount) > 0
                    ? residueInfo.amount - residueInfo.promiseAmount
                    : '0.00'
                  : residueInfo.amount
              }}</span>
              <span class="redF" v-else>{{ residueInfo.amount }}</span>
            </div>
            <div class="mb10">
              <span class="wid">应支付剩余余款（元）</span>
              <span class="redF">{{ residueInfo.amount }}</span>
            </div>
<!--            <div class="mb10" v-if="tranferType == 1">-->
<!--              <span class="wid">当前抵扣保证金（元）</span>-->
<!--              <span>{{ residueInfo.promiseAmount }}</span>-->
<!--            </div>-->
          </div>
          <div class="radio-group-wrap p50">
            <el-radio-group v-model="formData.payMethod">
              <el-radio label="2">自行转账</el-radio>
              <!-- <el-radio label="3">捷算支付</el-radio> -->
               <el-radio label="1">代收代付</el-radio>
            </el-radio-group>
          </div>
          <div class="content-group p50">
            <div class="group-tyep" :class="{ active: formData.payMethod == 2 }" v-if="formData.payMethod == 2">
              <el-form ref="formData" label-position="left" size="mini" label-width="100px">
                <el-form-item label="开户银行">{{ openBank }}</el-form-item>
                <el-form-item label="账户名">{{ accountName }}</el-form-item>
                <el-form-item label="账号">{{ bankAccount }}</el-form-item>
              </el-form>
              <div style="margin: 10px 0">
                <div v-for="(item, index) in formData.payEvidences" :key="index">
                  <span v-if="item.url" class="imgWrapss">
                    <el-image :src="item.url" style="width: 200px; height: 150px"></el-image>
                    <i @click.prevent.stop="del(index)" class="el-icon-delete"></i>
                  </span>
                </div>
                <Upload v-model="fileUrl" buttonText="上传缴费凭证（必填)" @fileNameEvt="payFileNameEvt" :size="true"></Upload>
              </div>
            </div>
             <div class="group-tyep" :class="{'active': formData.payMethod == 1,'right-active': formData.payMethod == 1}" v-if="formData.payMethod == 1">
              <el-form ref="formData" label-position="left" size="mini">
                <el-form-item label="银行账户" prop="bankAccount">
                  <div class="flex_auto">
                    <el-select v-model="formData.payBankAccount" @change="changeSelectBank('pay')">
                      <el-option v-for="item in bankList" :key="item.bankCard" :label="`${item.bankName}(${item.bankCard.slice(-4)})`" :value="item.bankCard"></el-option>
                    </el-select>
                    <el-button @click="$router.push({name:'managementPersonal'})" style="margin-left: 10px;"> 添加银行卡</el-button>
                  </div>
                </el-form-item>
                <div>
                  <el-checkbox v-model="checked"></el-checkbox>
                  我已阅读，并同意
                  <el-link v-if="residueInfo.userType == 2" style="color: rgb(4, 126, 255)" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwx6AHCjYAAHFqH6Bgu8140.pdf" target="_blank">《企业付款授权协议》</el-link>
                  <el-link v-if="residueInfo.userType == 1" style="color: rgb(4, 126, 255)" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwvCALLMNAAHGsdnGZ4I262.pdf" target="_blank">《个人付款授权协议》</el-link>
                </div>
              </el-form>
            </div>
            <!-- <div class="group-tyep" :class="{ active: formData.payMethod == 3 }">
              <el-form ref="formData" label-position="left" label-width="120px" size="mini">
                <el-form-item label="支持以下支付方式：">
                  <div class="pay">银行卡支付</div>
                  <div class="pay bef">微信支付</div>
                  <div class="pay befs">支付宝支付</div>
                </el-form-item>
                <div>
                  <el-checkbox v-model="checked"></el-checkbox> 我已阅读，并同意
                  <el-link v-if="residueInfo.userType == 2" style="color: #4f79d0" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwx6AHCjYAAHFqH6Bgu8140.pdf" target="_blank">《企业付款授权协议》</el-link>
                  <el-link v-if="residueInfo.userType == 1" style="color: #4f79d0" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwvCALLMNAAHGsdnGZ4I262.pdf" target="_blank">《个人付款授权协议》</el-link>
                </div>
                <div style="margin: 20px 0 0">
                  <el-button @click="payEvt()" :disabled="formData.payMethod != 3 || this.num == 0">点击付款</el-button>
                </div>
              </el-form>
            </div> -->
          </div>
        </div>
        <div slot="footer" class="btn">
          <el-button @click="show = false">取 消</el-button>
          <el-button class="sumbit" @click="saveAndSubmitBtn()">确认提交</el-button>
        </div>
      </el-dialog>
      <rePay :repayType="repayType" :show.sync="rePayDiaShow" :data.sync="listItem" @dialogCloses="rePayDiaShow = false" @diaSccessEvt="diaSccessEvt"></rePay>
      <payQrcode :qrUrl.sync="qrUrlData" :id.sync="diaId" @JSpayStatus="confirmpayStatus()" />
      <faceQrcode v-if="qrShow" ref="qr" @notify="notify"></faceQrcode>
       <!-- 转账提示 -->
      <paySure :pay.sync="payInfoSure"  @operateSureEvt="operateSureEvt"> </paySure>
    </div>
  </div>
</template>

<script>
import ChooseSearch from '@/components/ChooseSearch/index.vue'
import Dialog from '@/components/Dialog'
import publicFunction from '@/utils/publicFunction'
import HeaderImg from '@/components/HeaderImg'
import Upload from '@/components/Upload/UpLoad.vue'
import rePay from './components/repay.vue'
import { sessionStore } from '@/utils/data-management'
import Pagination from '@/components/Pagination'
import payQrcode from '@/components/payQrcode'
import faceQrcode from '@/components/faceQrcodes/index.vue'
import paySure from '@/components/paySure/index.vue'
export default {
  components: {
    ChooseSearch,
    Dialog,
    HeaderImg,
    Upload,
    rePay,
    Pagination,
    payQrcode,
    faceQrcode,
    paySure,
  },
  data() {
    return {
      repayType: '', //重新支付类型
      qrShow: false, //代收代付人脸识别
      headerList: [{ name: '首页', path: '/Home' }, { name: '我的投资' }],
      rePayDiaShow: false,
      listItem: {},
      diaShow: false,
      show: false,
      loading: false,
      Loading: false,
      tableData: [],
      paginationParam: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      search: {},
      formData: {
        payEvidences: [], //支付凭证
        payMethod: '2',
        id: '',
        cloudPayId: '',
        payBankAccount: '',
        payBankName: '',
        areaId: '',
        feeType: '1',
        userType: '',
        callbackId: '',
      },
      openBank: '',
      accountName: '',
      bankAccount: '',
      fileUrl: '',
      fileNameS: '',
      checked: true,
      diaId: '',
      tranferType: '', //1竞价2协议转让3预售
      residueInfo: {
        amount: '', //剩余金额
        bankAccount: '', //银行账户
        advancePaymentAmount: '',
        isAdvancePayment: '',
        promiseAmount: '',
        usePromiseAmount: false,
        userType: '',
      },
      qrUrlData: '', //支付二维码
      payStatus: false, //是否已支付
      areaConfigId: '',
      num: '',
      bankList: [],
      payInfoSure:{
        accountName: '',
        bankAccount: '',
        amount: '',
      },
    }
  },
  watch: {
    fileUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.payEvidences.push({
            url: newVal,
            name: this.fileNameS,
          })
          this.fileUrl = ''
        }
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'PropertyProjectDetails' || to.name == 'InvestDetail' || to.name == 'investSureBook') {
      let pageParams = {
        formInfo: this.search,
        paginationParam: this.paginationParam,
      }
      sessionStore.set('pageParams', JSON.stringify(pageParams))
    } else if (sessionStore.get('pageParams')) {
      sessionStore.remove('pageParams')
    }
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vim) => {
      let pageParams = sessionStore.get('pageParams')
      if (
       (from.name == "InvestDetail" || from.name == 'PropertyProjectDetails' || from.name == 'investSureBook') &&
        pageParams
      ) {
        pageParams = JSON.parse(pageParams)
        vim.search = pageParams.formInfo
        vim.paginationParam = pageParams.paginationParam
      }
      vim.getTransactionList()
    })
  },
  methods: {
    goSureBook(row){
      this.$router.push({name:'investSureBook',query:{id:row.listingApplyId}},)
    },
    goInvestDetail(row){
      this.$router.push({name:'InvestDetail',query:{id:row.id}},)
    },
    //代收代付获取银行卡列表以及选择
    changeSelectBank(flag) {
      if (this.bankList && this.bankList.length > 0) {
        if (this.formData.payBankAccount) {
          this.bankList.forEach((item) => {
            if (this.formData.payBankAccount == item.bankCard) {
              this.formData.payBankName = item.bankName
              this.formData.payAccountName = item.accountName;
            }
          })
        }
      } else {
        return this.$message.error(
          '请在页面右上的个人中心-账户管理里面添加银行卡'
        )
      }
    },
    // 获取代收代付银行卡
    async getBankList() {
      await this.$api.user
        .getMyCard({
          // type:
          //   this.residueInfo.userType == '2' ? 4 : this.residueInfo.userType,
        })
        .then((res) => {
          if (res.code == 1000 && res.data && res.data.length) {
            this.bankList = res.data
            this.bankList.forEach((item) => {
              if (item.isDefault == 1) {
                this.formData.payBankAccount = item.bankCard //银行账户 （必填）
                this.formData.payBankName = item.bankName //开户银行
                this.formData.payAccountName = item.accountName;
              }
            })
          }
        })
    },
    //重新支付
    diaPayEvtS(row,repayType) {
      this.listItem = row
      this.repayType = repayType
      this.rePayDiaShow = true
    },
    diaSccessEvt(v) {
      this.rePayDiaShow = v
      this.getTransactionList()
    },
    applyEvt(row) {
      this.$router.push({
        name: 'PropertyProjectDetails',
        query: {
          id: row.listingApplyId,
          status: Number(row.status),
          type: row.businessType,
          source: this.$store.state.cityArea.areaConfigId
        },
      })
    },
    async diaPayEvt(row) {
      this.tranferType = row.tranferType //1竞价2协议转让3预售
      this.diaId = row.id
      this.areaConfigId = row.areaConfigId
      this.show = true
      await this.getMyInvestmentDetail();
      await this.getCompanyInfo();
    },
    payMoneyEvt(){
      this.num = 0
      if (this.residueInfo.usePromiseAmount) {
        this.num = this.residueInfo.promiseAmount
          ? Number(this.residueInfo.amount - this.residueInfo.promiseAmount) > 0
            ? this.residueInfo.amount - this.residueInfo.promiseAmount
            : '0'
          : residueInfo.amount
      } else {
        this.num = this.residueInfo.amount
      }
    },
    async getMyInvestmentDetail() {
      this.$api.my.getMyInvestmentDetail({ id: this.diaId }).then((res) => {
        if (res.code === 1000 && res.data) {
          this.residueInfo = res.data
          this.getBankList()
          this.payMoneyEvt()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    confirmpayStatus(v) {
      this.payStatus = true
    },
    //捷算支付提交
    async payEvt() {
      const params = {
        amount: Number(this.num) * 100,
        remarks: '',
        linkId: this.diaId,
        payType: 0,
        areaConfigId: this.areaConfigId,
      }
      this.loading = true
      await this.$api.apply
        .perPay(params)
        .then((res) => {
          if (res.code === 1000) {
            this.qrUrlData = res.data
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false
        })
    },
    payFileNameEvt(v) {
      this.fileNameS = v
    },
    del(index) {
      if (this.formData.payEvidences.length > 0) {
        this.formData.payEvidences.splice(index, 1)
      }
    },
    //获取自行转账的相关银行信息
    async getCompanyInfo() {
      await this.$api.my
        .getFeeItem({ areaId: this.areaConfigId, feeType: '1' })
        .then((res) => {
          if (res.code === 1000) {
            this.openBank = res.data.bankName
            this.accountName = res.data.accountName
            this.bankAccount = res.data.bankCard
          }
        })
    },
    // 支付提交
    saveAndSubmitBtn() {
      if (this.formData.payMethod == 2) {
        if (!this.formData.payEvidences || (this.formData.payEvidences && !this.formData.payEvidences.length)) {
          return this.$message.error('请上传缴费凭证')
        }
      }
      if (
        this.formData.payMethod == 1 &&
        (!this.formData.payBankAccount || !this.formData.payBankName)
      )
        return this.$message.error('请选择代收代付的银行账户')
      if (this.formData.payMethod == 1 && !this.checked)
        return this.$message.error('请阅读并勾选付款协议')
      if (this.formData.payMethod == 3 && !this.payStatus && this.num > 0)
        return this.$message.error('请点击付款按钮进行扫码支付')
      this.formData.id = this.diaId
      this.formData.cloudPayId = this.qrUrlData.id
      this.formData.areaId = this.areaConfigId
      this.formData.userType = this.residueInfo.userType
      this.formData.feeType = this.tranferType == 1 ? '0' : '1'
      if(this.formData.payMethod == 2 && (!this.accountName || !this.bankAccount)) {
          return this.$message.error('当前区域未配置收款银行卡,暂不支持自行转账,请联系管理员')
      } else {
        this.payInfoSure = {
          accountName: this.formData.payMethod == 2 ? this.accountName :this.formData.payBankName,
          bankAccount: this.formData.payMethod == 2 ? this.bankAccount :this.formData.payBankAccount,
          amount: this.num,
        }
      }
    },
    operateSureEvt() {
      // if (this.formData.payMethod == 1) {
      //   this.qrShow = true
      // } else {
      //   this.operateEvt()
      // }
      this.operateEvt()
    },
    operateEvt() {
      this.loading = true
      this.$api.my
        .payMyInvestment(this.formData)
        .then((res) => {
          if (res.code === 1000) {
            this.show = false
            this.$message.success('余款支付成功')
            this.getTransactionList()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    notify(v) {
      this.qrShow = false
      if (v) {
        this.formData.callbackId = this.$refs.qr.callbackId
        setTimeout(() => {
          this.operateEvt()
        }, 500)
      }
    },
    //查询
    changeQuery(query) {
      if (query.chooseValue != 0) {
        this.$set(this.search, 'beginTime', query.chooseValue)
      } else {
        this.$set(this.search, 'beginTime', null)
      }
      if (query.searchValue) {
        this.$set(this.search, 'name', query.searchValue)
      } else {
        this.$set(this.search, 'name', null)
      }
      if (query.chooseIndex != -1) {
        this.$set(this.search, 'chooseIndex', query.chooseIndex)
      } else {
        this.$set(this.search, 'chooseIndex', -1)
      }
      this.paginationParam.pageNumber = 1
      this.getTransactionList()
    },
    //获取详情
    getTransactionList() {
      this.Loading = true
      const params = {
        userId: this.$store.state.userInfo.id,
        areaConfigId: this.$store.state.cityArea.areaConfigId,
        ...this.search,
        ...this.paginationParam,
      }
      this.$api.my
        .myInvestmentlist(params)
        .then((res) => {
          if (res.code == 1000) {
            this.tableData = []
            this.tableData = res.data
            this.paginationParam.total = res.total
          } else {
            this.$message.error(response.message)
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.Loading = false
        })
    },
    dialogSumbitL() {
      this.diaShow = false
    },
    dialogSumbitR() {
      this.diaShow = false
    },
  },
}
</script>
<style lang="scss" >
.radio-group-wrap .el-radio-group .el-radio{
  width: 100px !important;
}
.content-group{
  .active.right-active::after {
    left: 200px;
  }
}
.btn {
  text-align: center;
  margin: auto;
  display: block;
}
</style>
